(() => {
  const dataNode = document.getElementById('car-mist-variant-data');
  if (!dataNode || window.carMistVariantFix) return;
  const data = JSON.parse(dataNode.textContent);
  const variants = data.variants;
  const selector = `variant-picker[data-product-id="${data.productId}"][data-template-product-match="true"]`;
  const pickers = () => [...document.querySelectorAll(selector)].filter(picker => !picker.closest('product-card, quick-add-dialog'));
  const getInputs = (picker, option) => [...picker.querySelectorAll('input[type="radio"]')].filter(input => input.dataset.optionName === option);
  const getSelected = (picker, option) => getInputs(picker, option).find(input => input.checked)?.value;
  const showColors = picker => {
    const model = getSelected(picker, 'Model');
    const colors = new Set(variants.filter(variant => variant.option1 === model).map(variant => variant.option2));
    for (const input of getInputs(picker, 'Color')) {
      const label = input.closest('label');
      const hidden = !colors.has(input.value);
      if (label) {
        if (label.hidden !== hidden) label.hidden = hidden;
        const display = hidden ? 'none' : '';
        if (label.style.display !== display) label.style.display = display;
      }
    }
  };
  window.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const picker = input.closest(selector);
    if (!picker || picker.closest('product-card, quick-add-dialog')) return;
    const option = input.dataset.optionName;
    if (option !== 'Model' && option !== 'Color') return;
    const model = getSelected(picker, 'Model');
    const color = getSelected(picker, 'Color');
    const matches = variants.filter(variant => variant.option1 === model);
    const variant = matches.find(candidate => candidate.option2 === color) || matches.find(candidate => candidate.available) || matches[0];
    if (!variant) return;
    const colorInput = getInputs(picker, 'Color').find(candidate => candidate.value === variant.option2);
    if (colorInput && !colorInput.checked) {
      if (typeof picker.updateSelectedOption === 'function') picker.updateSelectedOption(colorInput);
      else colorInput.checked = true;
    }
    input.dataset.variantId = String(variant.id);
    if (colorInput) colorInput.dataset.variantId = String(variant.id);
    showColors(picker);
  }, true);
  const observed = new WeakSet();
  const initialize = () => {
    for (const picker of pickers()) {
      showColors(picker);
      if (observed.has(picker)) continue;
      new MutationObserver(() => showColors(picker)).observe(picker, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'data-current-checked', 'data-option-available'] });
      observed.add(picker);
    }
  };
  window.carMistVariantFix = { version: '2026-10-24.2', initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  customElements.whenDefined('variant-picker').then(initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
